import * as actionTypes from "../constants/actionTypes";


export function setInitialUrl(url){
    return (dispatch) => {
        dispatch({type: actionTypes.SET_INITIAL_URL, payload: url});
    };
}